import { ContainerYardOperationDialog } from '@host/components/container-change-position-dialog/ContainerYardOperationDialog'
import { ContainerYardOperationViewStore } from '@host/components/container-change-position-dialog/ContainerYardOperationViewStore'
import { parseBaplie } from '@host/utils/baplie-parser-utils'
import {
  CraneSplitSummary,
  EquipmentPlanningSummary,
  HatchCoverSummary,
  StoppagesSummary,
  useOperationsStore,
  VesselKPISummary,
} from '@tom-ui/operations'
import { VesselVisitDetails as PlanningVesselVisitDetails } from '@tom-ui/planning'
import { generalCargoDamageService } from '@tom-ui/storage'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { IssueStatus } from 'modules/operations/src/app/api'
import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router'

export const VesselVisitDetails = observer(() => {
  const { id } = useParams()
  const navigate = useNavigate()
  const vesselVisitId = Number(id)

  const {
    equipmentsVesselVisitUIStore,
    issueStore,
    hatchCoverMoveStore,
    stoppageStore,
    tenantConfigStore,
  } = useOperationsStore()

  const containerYardOperationViewStore = useMemo(() => new ContainerYardOperationViewStore(), [])

  const unresolvedIssueCount = issueStore.items.filter(
    i => i.carrierVisitIds.includes(vesselVisitId) && i.issueStatus === IssueStatus.Unresolved,
  ).length

  const stoppagesCount = stoppageStore.orderedItems.length

  const navigateToPage = (page: string) =>
    navigate(`${PATHS.visits.vesselVisits.url}/${vesselVisitId}/${page}`)

  return (
    <PlanningVesselVisitDetails
      onFetchEquipments={vid => equipmentsVesselVisitUIStore.getPlannedEquipments(vid)}
      onFetchIssues={vid => issueStore.getByCarrierVisitId(vid)}
      getOrderDamageAmounts={orderIds => generalCargoDamageService.getOrderDamageAmount(orderIds)}
      containerOperationDialog={
        <ContainerYardOperationDialog store={containerYardOperationViewStore} />
      }
      parseBaplie={parseBaplie}
      unresolvedIssueCount={unresolvedIssueCount}
      skipCraneSplit={tenantConfigStore.skipCraneSplit}
      stoppagesCount={stoppagesCount}
      hatchCoverSummary={
        <HatchCoverSummary
          store={hatchCoverMoveStore}
          visitId={vesselVisitId}
          onViewClick={() => navigateToPage(PATHS.visits.vesselVisits.hatchCovers.url)}
        />
      }
      stoppagesSummary={
        <StoppagesSummary
          store={stoppageStore}
          visitId={vesselVisitId}
          isVesselVisit
          isVisitDeparted={false}
          onViewClick={() => navigateToPage(PATHS.visits.vesselVisits.stoppages.url)}
        />
      }
      craneSplitCard={
        <CraneSplitSummary
          visitId={vesselVisitId}
          onViewClick={() =>
            navigate(
              `${PATHS.visits.vesselVisits.url}/${vesselVisitId}/${PATHS.visits.vesselVisits.craneSplit.url}`,
            )
          }
        />
      }
      equipmentPlanningCard={
        <EquipmentPlanningSummary
          onViewClick={() =>
            navigate(
              `${PATHS.visits.vesselVisits.url}/${vesselVisitId}/${PATHS.visits.vesselVisits.equipments.url}`,
            )
          }
        />
      }
      kpiSummary={
        <VesselKPISummary
          visitId={vesselVisitId}
          onViewClick={() =>
            navigate(
              `${PATHS.visits.vesselVisits.url}/${vesselVisitId}/${PATHS.visits.vesselVisits.kpi.url}`,
            )
          }
        />
      }
    />
  )
})
